/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Neat_Calm_Otter_DashInputs */

const en_neat_calm_otter_dash = /** @type {(inputs: Neat_Calm_Otter_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom section background`)
};

const de_neat_calm_otter_dash = /** @type {(inputs: Neat_Calm_Otter_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierter Abschnittshintergrund`)
};

/**
* | output |
* | --- |
* | "Custom section background" |
*
* @param {Neat_Calm_Otter_DashInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const neat_calm_otter_dash = /** @type {((inputs?: Neat_Calm_Otter_DashInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Neat_Calm_Otter_DashInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_neat_calm_otter_dash(inputs)
	return de_neat_calm_otter_dash(inputs)
});